import './dolezitostAktEu.scss';
import React, { ReactElement, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import {
  Col, FormGroup, Label, LoaderButton, Row, Select,
} from 'idsk-react-components';
import { BackButton } from 'slovlex-idsk-react-components';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import { DolezitostEnum, dolezitostNazov } from '../../../model/pracovnyKrok/Dolezitost';
import routes from '../../../routing/routes';
import { useClient } from '../../../context/ClientStatusContext';
import { changeDolezitost } from '../../../client/pracovnyKrok/dolezitostAktEuClient';
import useFieldErrorMessages from '../../useFieldErrorMessages';
import LegislativnyMaterialDetail from '../../../model/legislativnyMaterial/LegislativnyMaterialDetail';

interface Props {
  materialDetail: LegislativnyMaterialDetail;
}

const DolezitostAktEu = ({ materialDetail }: Props): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const {
    wrapClient: changeDolezitostClient,
    status: changeDolezitostStatus,
  } = useClient(changeDolezitost);
  const { displaySuccess } = useSuccessMessageContext();
  const navigate = useNavigate();
  const [dolezitost, setDolezitost] = useState(materialDetail.stupenDolezitostiAktu?.hodnota);
  const { getFieldErrorMessage, clearFieldErrorMessage } = useFieldErrorMessages();

  const changeDolezitostClick = async (): Promise<void> => {
    await changeDolezitostClient(type, year, index, dolezitost);
    navigate(routes.procesy.detail.withParams(type, year, index));
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  return (
    <div className="dolezitost-akt-eu">
      <FormGroup error={!!getFieldErrorMessage('dolezitost')}>
        <Row>
          <Col widthDesktop="one-third">
            <Label htmlFor="dolezitost">Stupeň dôležitosti návrhu aktu EÚ</Label>
          </Col>
        </Row>
        <Row>
          <Col widthDesktop="one-third">
            <Select
              id="dolezitost"
              width="full"
              name="dolezitost"
              value={dolezitost}
              onChange={
                ({ target }) => {
                  setDolezitost(target.value);
                  clearFieldErrorMessage('dolezitost');
                }
              }
              error={getFieldErrorMessage('dolezitost')}
            >
              <option key="Vyberte" value="" hidden>Vyberte</option>
              {(Object.values(DolezitostEnum) && Object.values(DolezitostEnum)?.length > 0) ? (
                <>
                  {Object.values(DolezitostEnum)
                    .map((dolezitostValue) => (
                      <option key={dolezitostValue} value={dolezitostValue}>
                        {dolezitostNazov(dolezitostValue)}
                      </option>
                    ))}
                </>
              ) : (
                <option key="emptyOption" value="emptyOption" disabled>
                  Nenašiel sa žiadny záznam.
                </option>
              )}
            </Select>
          </Col>
        </Row>
      </FormGroup>
      <div className="dolezitost-akt-eu__buttons-container">
        <LoaderButton
          size="large"
          className="dolezitost-akt-eu__submit-button"
          type="button"
          onClick={changeDolezitostClick}
          loading={changeDolezitostStatus.loading}
          disableOutsideClickWhileLoading
        >Uložiť
        </LoaderButton>
        <BackButton disabled={changeDolezitostStatus?.loading} />
      </div>
    </div>
  );
};

export default DolezitostAktEu;
